module.exports = __webpack_public_path__ + "static/media/tony.499cc7be.png";